import { z } from 'zod/v4-mini';

import { Schema, cz } from '@/utils/zodUtils.ts';

export type BasePumpEvent = {
  id: string;
  date: string;
};

export type PumpCartridgeFilledEvent = BasePumpEvent & {
  category: 'cartridge_filled';
  insulinDisplay?: number;
  insulinActual?: number;
};

export type PumpTubingFilledEvent = BasePumpEvent & {
  category: 'tubing_filled';
  primeSize?: number;
};

export type PumpCannulaFilledEvent = BasePumpEvent & {
  category: 'cannula_filled';
  primeSize?: number;
};

export type PumpProfileChangeEvent = BasePumpEvent & {
  category: 'profile_changed';
};

export type PumpPodChangeEvent = BasePumpEvent & {
  category: 'pod_changed';
};

export type PumpEvent =
  | PumpCartridgeFilledEvent
  | PumpTubingFilledEvent
  | PumpCannulaFilledEvent
  | PumpProfileChangeEvent
  | PumpPodChangeEvent;

export const pumpEventSchema: Schema<PumpEvent> = cz.camelCase(
  z.intersection(
    z.object({
      id: cz.id(),
      date: cz.datetime(),
    }),
    z.discriminatedUnion('category', [
      z.object({
        category: z.literal('cartridge_filled'),
        insulin_display: z.optional(z.number()),
        insulin_actual: z.optional(z.number()),
      }),
      z.object({
        category: z.literal(['tubing_filled', 'cannula_filled']),
        prime_size: z.optional(z.number()),
      }),
      z.object({
        category: z.literal('profile_changed'),
      }),
      z.object({
        category: z.literal('pod_changed'),
      }),
    ]),
  ),
);

export const getPumpEventTranslation = (
  category: PumpEvent['category'],
): string => {
  switch (category) {
    case 'cannula_filled':
      return 'models.pumpEventCategory.cannulaFilled';
    case 'cartridge_filled':
      return 'models.pumpEventCategory.cartridgeFilled';
    case 'tubing_filled':
      return 'models.pumpEventCategory.tubingFilled';
    case 'profile_changed':
      return 'models.pumpEventCategory.profileChanged';
    case 'pod_changed':
      return 'models.pumpEventCategory.podChanged';
  }
};
